module.exports = __webpack_public_path__ + "img/delixplus_banner.d5abfcd1.jpg";